const companyBrandReducer = (state = {}, action) => {
  switch (action.type) {
    case "GET_CAMPAIGN_DETAILS": {
      return {
        ...state,
        campaign: action.payload,
        message: null,
      };
    }
    case "SET_USER_CAMPAIGN": {
      return {
        ...state,
        message: action.payload,
      };
    }
    default: {
      return state;
    }
  }
};

export default companyBrandReducer;
